function  checkAutoWL(){
  var atwlItem = window.location.search.match(/\batwlitem=(.+)\b/);
  if (atwlItem !== null) {
    if (atwlItem.length > 0) {
      addToWishList(atwlItem[1]);
    }
  }
}

